/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Share_To_StoryInputs */

const en_label_share_to_story = /** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share to Story`)
};

const es_label_share_to_story = /** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir en la Historia`)
};

const fr_label_share_to_story = /** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager dans la Story`)
};

const de_label_share_to_story = /** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Story teilen`)
};

const id_label_share_to_story = /** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan ke Cerita`)
};

/** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */
const ja_label_share_to_story = en_label_share_to_story;

/** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */
const zh_label_share_to_story = en_label_share_to_story;

/** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */
const ar_label_share_to_story = en_label_share_to_story;

/** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */
const it_label_share_to_story = en_label_share_to_story;

/** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */
const ru_label_share_to_story = en_label_share_to_story;

/** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */
const pt_label_share_to_story = en_label_share_to_story;

/** @type {(inputs: Label_Share_To_StoryInputs) => LocalizedString} */
const ko_label_share_to_story = en_label_share_to_story;

/**
* | output |
* | --- |
* | "Share to Story" |
*
* @param {Label_Share_To_StoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_share_to_story = /** @type {((inputs?: Label_Share_To_StoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Share_To_StoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_share_to_story(inputs)
	if (locale === "es") return es_label_share_to_story(inputs)
	if (locale === "fr") return fr_label_share_to_story(inputs)
	if (locale === "de") return de_label_share_to_story(inputs)
	if (locale === "ja") return ja_label_share_to_story(inputs)
	if (locale === "zh") return zh_label_share_to_story(inputs)
	if (locale === "ar") return ar_label_share_to_story(inputs)
	if (locale === "id") return id_label_share_to_story(inputs)
	if (locale === "it") return it_label_share_to_story(inputs)
	if (locale === "ru") return ru_label_share_to_story(inputs)
	if (locale === "pt") return pt_label_share_to_story(inputs)
	return ko_label_share_to_story(inputs)
});